<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import ReviewRatingStars from "@apps/reviews/components/RatingStars/ReviewRatingStars.svelte";
    import ReviewsTheme from "@apps/reviews/components/ReviewsTheme/ReviewsTheme.svelte";
    import ReviewsStorefrontValuesService from "@apps/reviews/services/ReviewsStorefrontValuesService";
    import { lastValueFrom } from "rxjs";
    import { onMount } from "svelte";

    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";
    import T from "@components/T.svelte";

    import ReviewsSummaryQuery from "./queries/ReviewsSummaryQuery";
    import ReviewsSummaryService from "./services/ReviewsSummaryService";

    export let reviewsStorefrontValuesService: ReviewsStorefrontValuesService;
    export let reviewsSummaryService: ReviewsSummaryService;
    export let reviewsSummaryQuery: ReviewsSummaryQuery;
    export let afterWidgetInject: () => void;

    const reviewsBranding$ =
        reviewsStorefrontValuesService.selectReviewsBrandingOptions();
    const reviewsCount$ = reviewsSummaryQuery.count$;
    const reviewsAvgRating$ = reviewsSummaryQuery.avgRate$;
    const status$ = reviewsSummaryQuery.status$;

    onMount(() => {
        lastValueFrom(reviewsSummaryService.getReviewsSummary());

        afterWidgetInject();
    });

    $: showSkeleton = $status$ === STATUS.INITIAL_LOADING;
</script>

{#if $reviewsBranding$}
    <ReviewsTheme branding={$reviewsBranding$}>
        <div class="gw-rv-trust-badge">
            <p class="gw-rv-trust-badge__count">
                {#if showSkeleton}
                    <BaseSkeleton height="1em" width="100px" />
                {:else}
                    {$reviewsCount$}
                {/if}
            </p>
            <p class="gw-rv-trust-badge__verified-text">
                <T
                    namespace="reviews.ReviewsTrustBadgeWidget"
                    translationKey="verified_reviews"
                />
            </p>
            <div class="gw-rv-trust-badge__rating">
                {#if showSkeleton}
                    <BaseSkeleton height="24px" width="120px" />
                {:else if $reviewsAvgRating$}
                    <ReviewRatingStars
                        rating={$reviewsAvgRating$}
                        width="24"
                        height="24"
                    />
                {/if}
            </div>
        </div>
    </ReviewsTheme>
{/if}

<style lang="postcss" global>
    .gw-rv-trust-badge {
        display: flex;
        flex-direction: column;
        padding: 2.25em 1.125em;
        border-radius: 8px;

        &__count {
            font-size: 3em;
            font-weight: 600;
            color: inherit;
            text-align: center;
            line-height: 1;
            margin: 0;
        }

        &__verified-text {
            font-size: 1em;
            line-height: 1.5em;
            font-weight: 600;
            text-align: center;
            padding-top: 0.25em;
            color: #98a2b3;
            margin: 0;
            text-transform: uppercase;
        }

        &__rating {
            padding-top: 0.625em;
            display: flex;
            justify-content: center;
        }
    }
</style>
